<script lang="ts">
	import type { Addon, AddonGroup, ExtraGroup, OptionGroup } from "proto/menu";
	import type { ChoiceGroup, FoodMenuChoiceIssueReport, IDed } from "$lib/def/food-menu";
	import type { Subject } from "rxjs";
	
	import { createEventDispatcher, onDestroy } from "svelte";
	import RestaurantMenuChoice from "./RestaurantMenuChoice.svelte";

	export let groups: (OptionGroup | ExtraGroup | AddonGroup)[];

	/**
	 * if `true` then it is assumed the list items each host additional options and extra
	 */
	export let host: { id: string, name: string } | null = null;

	export let hostIndex: string;

	export let hostPosition: number = 0;

	export let selectedGroups: ChoiceGroup[];
	
	export let reporter: Subject<FoodMenuChoiceIssueReport>;

	const dispatch = createEventDispatcher();
	// let hoistedAddons: (Addon & { options?:OptionGroup[], extras?:ExtraGroup[] })[] = [];

	$: updates = selectedGroups ?? []; // selection is overridden every time selectedGroups changes

	/**
	 * Update our selected groups with the new selection.
	 * @param group A group from menu data. Typically something like "What Sides?"
	 * containing a list of choices like "Fries", "Salad", "Rice" etc.
	 * @param items Array of selected choice(s) as objects with at least an id property.
	 * Could be an empty array if all choices are unselected.
	 */
	function onUpdate<T extends (OptionGroup | ExtraGroup | AddonGroup)>(group: T, items: IDed[]) {
		// if (host) {
		// 	hoistedAddons = items.map(({id}) => group.items.find(item => item.id === id) as Addon);
		// }

		// this is a scanner to add new groups, update existing ones and remove any groups with no items
    const newGroups = [...updates]; // prevent mutation of the original array
		let idx = newGroups.findIndex(g => g.id === group.id);
		if (~idx) {
			if (items.length) {
				newGroups[idx].items = items; // replace the item selection
			} else {
				newGroups.splice(idx, 1); // remove the group which previously had item
			}
		} else {
			if (items.length) { // add a new group (I can't see how length can ever be 0, but let's keep it readable)
				newGroups.push({ id: group.id, items } as ChoiceGroup);
			}
		}
		updates = newGroups; // replace our previous selection with the new one
		dispatch('update', newGroups);
	}

	onDestroy(() => {
		// dispatch('update', []); // from G, this cannot be helpful - please provide a reason if this is needed
	});
</script>

{#if groups?.length}
	{#each groups as group, index (group.id)}
		{@const selected = selectedGroups?.find(g => g.id === group.id)}
		<RestaurantMenuChoice {group} {host} hostPosition={index + hostPosition} preselected={selected?.items} hostIndex={`${hostIndex}${group.id}`} on:update={e => onUpdate(group, e.detail)} {reporter}/>
	{/each}
{/if}
